export default __webpack_public_path__ + "static/media/outages_current_blue.d5b467e2.svg";